import { useRequest } from "ahooks";
import { useEffect, useState } from "react";
import useSWR from "swr";
import { SeaBayPackage } from "./SeaBayContent";
import { useUserInfo } from "../../hooks";

async function createTrade(packageId: number, accountId?: number) {
  if (!packageId) {
    return;
  }
  const res = await fetch(`/api/v3/payment/topup/trade`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify({
      topup_package_id: packageId,
      account_id: accountId,
    }),
  });
  const data = await res.json();
  return data as {
    code_url: string;
    order_id: string;
  };
}

async function getSeaBayPayment() {
  const res = await fetch(`/api/v3/payment/topup/package`, {
    headers: {
      Authorization: process.env.API_BASIC_AUTH_V2 ?? "",
    },
  });
  const data = await res.json();
  const seaBayPackage = (data?.topup_price_list || []) as SeaBayPackage[];
  return seaBayPackage;
}

async function getTradeStatus({
  packageId,
  accountId,
  orderId,
}: {
  packageId: number;
  accountId: number;
  orderId: string;
}) {
  console.log("orderId=>", orderId);
  const res = await fetch(`/api/v3/payment/topup/payment`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify({
      topup_package_id: packageId,
      account_id: accountId,
      order_id: orderId,
    }),
  });
  const data = await res.json();
  return data as {
    order: {
      trade_status: string;
    };
  };
}

export const useCreateTrade = () => {
  const { accountInfo } = useUserInfo();
  const {
    runAsync: createTradeRun,
    loading: createTradeLoading,
    data: createTradeData,
  } = useRequest(
    (packageId: number) => createTrade(packageId, accountInfo?.account_id),
    {
      manual: true,
    },
  );
  return {
    createTradeRun,
    createTradeLoading,
    createTradeData,
  };
};

export const useGetSeaBayPayment = () => {
  const { data, isLoading } = useSWR("sea-bay-payment", getSeaBayPayment, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    keepPreviousData: true,
  });
  return {
    data,
    isLoading,
  };
};

export const useGetTradeStatus = (afterSuccess?: () => void) => {
  const { accountInfo, refetchSeaBayCount } = useUserInfo();
  const {
    run: getTradeStatusRun,
    loading: getTradeStatusLoading,
    data: getTradeStatusData,
    cancel: cancelPolling,
  } = useRequest(
    ({ packageId, orderId }: { packageId: number; orderId: string }) =>
      getTradeStatus({
        packageId,
        accountId: accountInfo?.account_id!,
        orderId,
      }),
    {
      manual: true,
      pollingInterval: 1500,
      onSuccess: (data) => {
        if (data?.order?.trade_status === "SUCCESS") {
          cancelPolling();
          refetchSeaBayCount();
          afterSuccess?.();
        }
      },
    },
  );
  return {
    getTradeStatusRun,
    getTradeStatusLoading,
    getTradeStatusData,
    cancelPolling,
  };
};
